import { Feature } from 'config/features';

import { MasterData_CategoryType } from 'proto/Hotel/Hotel';
import { Session } from 'proto/User/Session';

import { SortOrder } from '../Search/form';

export interface SearchFormDefaults {
    form?: {
        destinationLabel?: string;
        queryFilter?: {
            package?: {
                days?: {
                    min?: number;
                    max?: number;
                };
            };
        };
    };
    searchFormUrl?: string;
    defaultAirport?: string;
}

interface DateDescription {
    value: string;
    description: string;
}

interface TravelDate {
    departureDate: DateDescription;
    returnDate: DateDescription;
}

export interface TravelDates {
    lastminute: TravelDate;
    allinclusive: TravelDate;
    package: TravelDate;
    earlybird: TravelDate;
}

export interface ChangedFilter {
    travellers?: string;
    roomCount?: string;
    travelDuration?: string;
    departureDate?: string;
    retrunDate?: string;
    destination?: string;
}

export interface SwitchData {
    mapping?: {
        [key: string]: string;
    };
    redirectUrl?: string;
    changedFilter?: ChangedFilter;
    originUrl?: string;
    destinationLabel?: string;
}

export interface C24PointsCashBack {
    threshold: number;
    redeemablePoints: number;
    redeemableAmount: number;
}

export interface RatingProps {
    threshold: number;
    labelKey: string;
}

export interface RatingConfig {
    thresholds: RatingProps[];
    filterThresholds: RatingProps[];
    targetScale: number;
    maxRatingsPerView: number;
}

export enum BackendInformationKeys {
    SearchFormDefaults = 'searchFormDefaults',
    TravelDates = 'travelDates',
    HotelSwitchData = 'hotelSwitchData',
    HolidayHomeSwitchData = 'hotelSwitchData',
    CmxSwitchData = 'hotelSwitchData',
    BaseUrl = 'baseUrl',
    C24Points = 'c24Points',
}
export enum Environment {
    Development = 'development',
    Testing = 'testing',
    Integration = 'integration',
    Production = 'production',
}

interface BackendInformationDataMap {
    [BackendInformationKeys.SearchFormDefaults]: SearchFormDefaults;
    [BackendInformationKeys.TravelDates]: TravelDates;
    [BackendInformationKeys.HotelSwitchData]: SwitchData;
    [BackendInformationKeys.HolidayHomeSwitchData]: SwitchData;
    [BackendInformationKeys.CmxSwitchData]: SwitchData;
    [BackendInformationKeys.BaseUrl]: string;
    [BackendInformationKeys.C24Points]: C24PointsCashBack;
}

export interface BackendInformationFuncModule {
    getData: {
        <K extends keyof BackendInformationDataMap>(
            key: K
        ): BackendInformationDataMap[K]; // Für spezifizierte Schlüssel
        <ReturnType = string>(key: string): ReturnType; // Fallback für alle anderen Schlüssel
    };
    getToplevelDomain(): string;
    getSsoData(): SsoInformation;
    getCurrentSsoData(): SsoInformation;
    onNewSsoInformation(response: Session): void;
    featureActive(name: Feature): boolean;
    getDeviceInformation(): DeviceInformation;
    trigger(eventName: string, data?: unknown): void;
    on(eventName: string, callback: () => void): void;
    off(eventName: string): void;
    getI18nScheme(): string;
    getUrlPrefix(): string;
    isBoUser(): boolean;
    checkDynamicFeature(
        name: string,
        callback: (isActive: boolean) => void,
        timeout?: number
    ): void;
}

export interface SsoInformation {
    goldClub?: boolean;
    ssoId?: number;
    hasLogin?: boolean;
    firstname?: string;
    lastname?: string;
    displayName?: string;
    isPointAccount?: boolean;
    isPointAccountRequested?: boolean;
}

export interface DeviceInformation {
    deviceOutput?: string;
    deviceType?: string;
    environment?: Environment;
}

export interface HotelData {
    name: string;
    categoryType: MasterData_CategoryType;
    category: number;
    id: number;
    region?: string;
    isCheckGpt: boolean;
}

export interface DefaultHotelSort {
    sort: SortOrder;
}

export interface ChattyData {
    holdingVersion: string;
    packageVersion: string;
}
